import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';


@Injectable()

export class UpdateLobService
{
    private subject = new BehaviorSubject<string>("MEMBER");
    lobSrc = this.subject.asObservable();
constructor()
{

}
setLob(lobSrc)
{
  this.subject.next(lobSrc);
}
}


// WEBPACK FOOTER //
// ./src/app/shared/update-lob.service.ts